import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-step-drivers-manual',
  templateUrl: './workflow-step-drivers-manual.component.html',
  styleUrls: ['./workflow-step-drivers-manual.component.css']
})
export class WorkflowStepDriversManualComponent implements OnInit {

  isLinear = true;

  constructor() {}

  ngOnInit() {
  }
}
